import { fetchJson } from '../lib/http.js';

export async function fetchHowToVideos() {
  const data = await fetchJson('/api/how-to-videos/');
  return Array.isArray(data?.videos) ? data.videos : [];
}

export async function fetchHowToLiveStatus() {
  return fetchJson('/api/how-to-live/status/');
}
